import AdblockerModal from "components/Pages/Gallery/GalleryContent/AdblockerModal.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useDownloadRequest } from "../../../hooks/useDownloadRequest.tsx";
import { useAdblockerModal } from "hooks/useAdblockerModal.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";

const DownloadActionComponent = ({
  itemId,
  iconName,
  tooltipDisabled,
  folderId,
  withTitle,
}) => {
  const { getTextByKey } = useContent();
  const { isMailAvailable } = useMail();
  const { handleDownload, isWaitingForResponse } = useDownloadRequest({
    itemId,
    folderId,
  });

  const toolipId = `downloadActionIcon${
    itemId ? "-" + itemId : folderId ? "-" + folderId : ""
  }`;
  const { setModal } = useModal();
  const displayAdblockerPopUp = useAdblockerModal();

  const handleDownloadClick = async () => {
    if (displayAdblockerPopUp) {
      setModal({
        modal: AdblockerModal,
        modalSize: "full-modal",
      });
    } else {
      handleDownload();
    }
  };

  return isMailAvailable() ? (
    <section
      onClick={() => {
        handleDownloadClick();
      }}
      className={isWaitingForResponse ? "disabled" : ""}
    >
      {!tooltipDisabled && !withTitle ? (
        <Tooltip id={toolipId} tooltipTextKey="download-icon-tooltip-text" top>
          <Icon
            name={iconName || "download"}
            gray
            clickable
            disabled={isWaitingForResponse}
          />
        </Tooltip>
      ) : (
        <Icon
          name={iconName || "download"}
          gray
          clickable
          disabled={isWaitingForResponse}
        />
      )}
      {withTitle && getTextByKey("download-icon-tooltip-text")}
    </section>
  ) : null;
};

export default DownloadActionComponent;
